"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _shared = require("./shared");

var _jsxRuntime = require("react/jsx-runtime");

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledEntryButtonPlaceholder = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: ", ";\n  max-width: ", ";\n  min-width: ", ";\n  margin-right: 0.5rem;\n"])), function (p) {
  return p.widthPlaceholder;
}, function (p) {
  return p.widthPlaceholder;
}, function (p) {
  return p.widthPlaceholder;
});

var Wrapper = function Wrapper(_ref) {
  var _pickem$usersBets, _pickem$usersBets2;

  var index = _ref.index,
      pickem = _ref.pickem,
      isActive = _ref.isActive,
      activeBet = _ref.activeBet,
      handleEnterClicked = _ref.handleEnterClicked,
      handleRowClicked = _ref.handleRowClicked;

  var _useSelector = (0, _reactRedux.useSelector)(function (s) {
    return s.betbar;
  }),
      hasPickemsAllowingMultipleBets = _useSelector.hasPickemsAllowingMultipleBets;

  var widthPlaceholder = hasPickemsAllowingMultipleBets ? "50px" : "50px";
  var prizePool = (pickem === null || pickem === void 0 ? void 0 : pickem.prizeFund) || (pickem === null || pickem === void 0 ? void 0 : pickem.promoPrizeFund);
  var isPromoPrize = (pickem === null || pickem === void 0 ? void 0 : pickem.promoPrizeFund) > 0;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_shared.FootballMatch, {
      pickem: pickem,
      showLogos: true,
      isActive: isActive
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_shared.TextStack, {
      label: pickem !== null && pickem !== void 0 && pickem.activeBet ? "Entered" : "Entry",
      value: (pickem === null || pickem === void 0 ? void 0 : pickem.stake) || "FREE",
      isMoney: (pickem === null || pickem === void 0 ? void 0 : pickem.stake) > 0,
      isCentered: true
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_shared.TextStack, {
      label: isPromoPrize ? "Promo Prize" : "Prize Pool",
      value: prizePool,
      isMoney: true,
      isCentered: true
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledEntryButtonPlaceholder, {
      widthPlaceholder: widthPlaceholder,
      children: pickem !== null && pickem !== void 0 && pickem.maxBetsPerUser && (pickem === null || pickem === void 0 ? void 0 : (_pickem$usersBets = pickem.usersBets) === null || _pickem$usersBets === void 0 ? void 0 : _pickem$usersBets.length) < (pickem === null || pickem === void 0 ? void 0 : pickem.maxBetsPerUser) && pickem !== null && pickem !== void 0 && pickem.activeBet ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_shared.EntryButton, {
        isSuccess: true,
        onClick: function onClick(e) {
          return handleEnterClicked(e, index, pickem, true);
        },
        children: "Enter"
      }) : !(pickem !== null && pickem !== void 0 && pickem.activeBet) && (pickem === null || pickem === void 0 ? void 0 : (_pickem$usersBets2 = pickem.usersBets) === null || _pickem$usersBets2 === void 0 ? void 0 : _pickem$usersBets2.length) < (pickem === null || pickem === void 0 ? void 0 : pickem.maxBetsPerUser) || !(pickem !== null && pickem !== void 0 && pickem.activeBet) ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_shared.EntryButton, {
        isSuccess: true,
        onClick: function onClick(e) {
          return handleEnterClicked(e, index, pickem);
        },
        children: "Enter"
      }) : null
    })]
  });
};

var _default = Wrapper;
exports.default = _default;